// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".baseline[data-v-b815c56a]{vertical-align:baseline}", ""]);
// Exports
module.exports = exports;
